/* import __COLOCATED_TEMPLATE__ from './nav-dots.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();